import styled from "styled-components";
import Checkbox from "@streeteasy/design-system/deprecated/Checkbox";
import colors from "@streeteasy/design-system/deprecated/colors";
import UITitle from "@streeteasy/design-system/deprecated/Title";
import XButton from "@streeteasy/design-system/deprecated/XButton";

import SEModal from "../../../../shared/components/SEModal";
import { largeScreen } from "../../../../shared/constants/screenSizes";

const UIModal = styled(SEModal)`
  margin-top: 150px;

  @media screen and (max-width: ${largeScreen}px) {
    margin-top: 5px;
  }
`;

const ActionBox = styled.div`
  background: ${colors.mouseGrey};
  border-top: 1px solid ${colors.rabbitGrey};
  padding: 30px 70px;

  @media screen and (max-width: ${largeScreen}px) {
    background: white;
    border: none;
    padding: 13px 33px 70px;
  }
`;

const Body = styled.div`
  background: white;
  padding: 65px 70px 30px;

  @media screen and (max-width: ${largeScreen}px) {
    padding: 42px 53px 30px;
  }
`;

const Container = styled.div`
  width: 580px;

  @media screen and (max-width: ${largeScreen}px) {
    text-align: center;
    width: calc(100vw - 50px);
  }
`;

const Title = styled(UITitle).attrs({
  type: "primarySm"
})`
  margin: 0 0 10px;

  @media screen and (max-width: ${largeScreen}px) {
    margin: 36px 0 5px;
  }
`;

const CheckboxView = styled(Checkbox)`
  margin: 27px 0 2px;

  @media screen and (max-width: ${largeScreen}px) {
    justify-content: center;
    margin: 32px 0 0;
  }
`;

const StyledXButton = styled(XButton)`
  position: absolute;
  right: 25px;
  top: 25px;
`;

UIModal.displayName = "SEModal";
ActionBox.displayName = "ActionBox";
Body.displayName = "Body";
CheckboxView.displayName = "CheckboxView";
Container.displayName = "Container";
StyledXButton.displayName = "StyledXButton";
Title.displayName = "Title";

export {
  ActionBox,
  Body,
  CheckboxView,
  Container,
  StyledXButton,
  Title,
  UIModal
};
